import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.3876 19.9783C10.6208 19.6345 4.36546 13.3797 4.02223 5.61241L7.53679 4.20639L9.68598 8.50475L8.02153 9.33673V9.95695C8.02153 13.2773 10.7232 15.9785 14.0431 15.9785H14.6633L15.4957 14.3145L19.7936 16.4632L18.3876 19.9783ZM21.5173 15.0808L15.4957 12.07L14.1489 12.5191L13.4449 13.9266C11.7092 13.6667 10.3338 12.2908 10.0734 10.5551L11.4814 9.85107L11.93 8.50475L8.91924 2.48323L7.6492 2L2.63126 4.00718L2 4.93901C2 14.3466 9.65386 22 19.061 22L19.9928 21.3692L22 16.3513L21.5173 15.0808Z", clipRule: "evenodd" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconCall = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconCall.displayName = "IconCall";

export { IconCall };
